import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setMessage } from './message';
import workorderService from '../services/work-order.service';


export const fetchWorkOrderStatistics = createAsyncThunk(
  'workorder/fetchWorkOrderStatistics',
  async (_, thunkAPI ) => {
    try {
      const response = await workorderService.getWorkOrderStatistics();
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchOpenWorkOrderStatistics = createAsyncThunk(
  'workorder/fetchOpenWorkOrderStatistics',
  async (_, thunkAPI ) => {
    try {
      const response = await workorderService.getOpenWorkOrderStatistics();
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchWorkOrderList = createAsyncThunk(
  'workorder/fetchWorkOrderList',
  async (
    { customer_id, profile_id, page, pagesize, search, groupId, ordering },
    thunkAPI,
  ) => {
    try {
      const response = await workorderService.getWorkOrderList(
        customer_id,
        profile_id,
        page,
        pagesize,
        search,
        groupId,
        ordering,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchWorkOrderListByfilter = createAsyncThunk(
  'workorder/fetchWorkOrderListByfilter',
  async ({ page, pagesize, search, ordering, groupId }, thunkAPI) => {
    try {
      const response = await workorderService.getWorkOrderListByFilter(
        page,
        pagesize,
        search,
        ordering,
        groupId,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchWorkOrderListByfilterNoPagination = createAsyncThunk(
  'workorder/fetchWorkOrderListByfilterNoPagination',
  async ({ fields }, thunkAPI) => {
    try {
      const response =
        await workorderService.getWorkOrderListByFilterNoPagination(
          // page,
          // pagesize,
          fields,
        );

      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchWorkOrderDropdown = createAsyncThunk(
  'workorder/fetchWorkOrderDropdown',
  async ({ page, pagesize, search, groupId, ordering }, thunkAPI) => {
    try {
      const response = await workorderService.getWorkOrderDropdown(
        page,
        pagesize,
        search,
        groupId,
        ordering,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchWorkOrderForExcess = createAsyncThunk(
  'workorder/fetchWorkOrderForExcess',
  async ({ page, pagesize, search, groupId, ordering }, thunkAPI) => {
    try {
      const response = await workorderService.workOrderForExcessStock(
        page,
        pagesize,
        search,
        groupId,
        ordering,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchWorkOrderStatusData = createAsyncThunk(
  'workorder/fetchWorkOrderStatusData',
  async ({ page, pagesize, search, groupId, ordering }, thunkAPI) => {
    try {
      const response = await workorderService.getWorkOrderStatusList(
        page,
        pagesize,
        search,
        groupId,
        ordering,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchArchivedWorkOrderList = createAsyncThunk(
  'workorder/fetchArchivedWorkOrderList',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await workorderService.getArchiveWorkOrderList(
        page,
        pagesize,
        search,
        ordering,
      );
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchWorkOrderById = createAsyncThunk(
  'workorder/fetchWorkOrderById',
  async (dieProfileId, { rejectWithValue }) => {
    try {
      const response = await workorderService.getWorkOrderById(dieProfileId);
      return response.data; // Return the profile data
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchWorkOrderReport = createAsyncThunk(
  'workorder/fetchWorkOrderReport',
  async ({ customer_id, die_id, search }, { rejectWithValue }) => {
    try {
      const response = await workorderService.getWorkOrderReport(
        customer_id,
        die_id,
        search,
      );
      return response.data; // Return the profile data
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchDieWiseWorkOrderReport = createAsyncThunk(
  'workorder/fetchDieWiseWorkOrderReport',
  async ({ customer_id }, { rejectWithValue }) => {
    try {
      const response = await workorderService.getDieWiseWorkOrderReport(customer_id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchViewWorkOrderById = createAsyncThunk(
  'workorder/fetchViewWorkOrderById',
  async ({ id, page, pagesize, search, ordering, print, }, thunkAPI) => {
    try {
      const response = await workorderService.getViewWorkOrderById(
        id,
        page,
        pagesize,
        search,
        ordering,
        print,
      );
      return response.data; // Return the profile data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);
export const fetchViewWorkOrderByCloseOrderId = createAsyncThunk(
  'workorder/fetchViewWorkOrderByCloseOrderId',
  async ({ id, formData }, thunkAPI) => {
    try {
      const response = await workorderService.getViewWorkOrderByCloseOrderId(
        id,
        formData,
      );
      return response.data; // Return the profile data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);
export const fetchWorkOrderItemById = createAsyncThunk(
  'workorder/fetchWorkOrderItemById',
  async ({ id, page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await workorderService.getItemByWorkOrderId(
        id,
        page,
        pagesize,
        search,
        ordering,
      );
      return Array.isArray(response.data.data) ? response.data.data : [];
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);
export const fetchExcessStockCountInWorkorder = createAsyncThunk(
  'workorder/fetchExcessStockCountInWorkorder',
  async ({ profileId, length, alloyId, temperId }, thunkAPI) => {
    try {
      const response = await workorderService.getExcessStockCountInWorkorder(
        profileId,
        length,
        alloyId,
        temperId,
      );
      return response.data.data ? response.data.data : [];
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);
export const fetchWorkorderByProfileId = createAsyncThunk(
  'workorder/fetchWorkorderByProfileId',
  async ({ id, page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await workorderService.getWorkorderByProfileId(
        id,
        page,
        pagesize,
        search,
        ordering,
      );
      return Array.isArray(response.data.data) ? response.data.data : [];
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

export const createWorkOrder = createAsyncThunk(
  'workorder/createWorkOrder',
  async ({ values }, thunkAPI) => {
    try {
      const response = await workorderService.addWorkOrder(values);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const createPriority = createAsyncThunk(
  'workorder/createPriority',
  async ({ values }, thunkAPI) => {
    try {
      const response = await workorderService.addPriority(values);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const updateWorkOrder = createAsyncThunk(
  'workorder/updateWorkOrder',
  async ({ id, values }, thunkAPI) => {
    try {
      const response = await workorderService.EditWorkOrder(id, values);
      return response.data; // Return the updated die group data
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const deleteWorkOrder = createAsyncThunk(
  'workorder/deleteWorkOrder',
  async (id, thunkAPI) => {
    try {
      await workorderService.archiveWorkOrder(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const unArchiveWorkOrder = createAsyncThunk(
  'workorder/unArchiveWorkOrder',
  async (id, thunkAPI) => {
    try {
      await workorderService.unArchiveWorkOrder(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

const initialState = {
  data: [], // List
  list: [],
  statisticsData: [],
  openWorkOrderStatisticsData: [],
  totalWorkOrderData: [],
  totalPages: 0,
  currentPage: 1,
  totalRecord: 0,
  status: 'idle',
  error: null,
  loading: false,
  hasMore: true,
};

const workorderSlice = createSlice({
  name: 'workorder',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetWorkOrderData: state => {
      state.data = []; // This will clear the list
    },
    resetWorkOrderList: state => {
      state.list = []; // This will clear the list
    },
    resetCurrentWorkOrderPage: state => {
      state.currentPage = 1;
    },
  },
  extraReducers: builder => {
     builder
      .addCase(fetchWorkOrderStatistics.pending, state => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(fetchWorkOrderStatistics.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.statisticsData = action.payload.data || []; // Update to match your API response
        state.loading = false;
      })
      .addCase(fetchWorkOrderStatistics.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });
   
       builder
      .addCase(fetchOpenWorkOrderStatistics.pending, state => {
        state.status = 'loading';
        state.loading = true;
      })
      .addCase(fetchOpenWorkOrderStatistics.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.openWorkOrderStatisticsData = action.payload.data || []; // Update to match your API response
        state.loading = false;
      })
      .addCase(fetchOpenWorkOrderStatistics.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });
    builder
      .addCase(fetchWorkOrderList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchWorkOrderList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchWorkOrderList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });

    builder
      .addCase(fetchWorkOrderListByfilter.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchWorkOrderListByfilter.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchWorkOrderListByfilter.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });
    builder
      .addCase(fetchWorkOrderListByfilterNoPagination.pending, state => {
        state.status = 'loading';
      })
      .addCase(
        fetchWorkOrderListByfilterNoPagination.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.totalWorkOrderData = action.payload.data || [];
        },
      )
      .addCase(
        fetchWorkOrderListByfilterNoPagination.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
        },
      );

    builder
      .addCase(fetchWorkOrderDropdown.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchWorkOrderDropdown.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchWorkOrderDropdown.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });

    builder
      .addCase(fetchWorkOrderForExcess.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchWorkOrderForExcess.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchWorkOrderForExcess.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });
    builder
      .addCase(fetchWorkOrderStatusData.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchWorkOrderStatusData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchWorkOrderStatusData.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });
    builder
      .addCase(fetchArchivedWorkOrderList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchArchivedWorkOrderList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || []; // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.list = [...state.list, ...action.payload.results.data];
        state.hasMore = !!action.payload.next;
      })
      .addCase(fetchArchivedWorkOrderList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });
    builder
      .addCase(fetchWorkOrderById.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkOrderById.fulfilled, (state, action) => {
        state.loading = false;
        state.activeProfileRecord = action.payload;
      })
      .addCase(fetchWorkOrderById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchDieWiseWorkOrderReport.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDieWiseWorkOrderReport.fulfilled, (state, action) => {
        state.loading = false;
        state.activeProfileRecord = action.payload;
      })
      .addCase(fetchDieWiseWorkOrderReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchWorkOrderReport.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkOrderReport.fulfilled, (state, action) => {
        state.loading = false;
        state.activeProfileRecord = action.payload;
      })
      .addCase(fetchWorkOrderReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(createWorkOrder.pending, state => {
        state.status = 'loading';
      })
      .addCase(createWorkOrder.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(createWorkOrder.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
    builder
      .addCase(updateWorkOrder.pending, state => {
        state.status = 'loading';
      })
      .addCase(updateWorkOrder.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const updateDieProfile = action.payload;
        const index = state.data.findIndex(
          group => group.id === updateDieProfile.id,
        ); // Find the index of the updated group
        if (index !== -1) {
          state.data[index] = updateDieProfile; // Replace the old group with the updated one
        }
      })
      .addCase(updateWorkOrder.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
    builder
      .addCase(deleteWorkOrder.pending, state => {
        state.status = 'loading';
      })
      .addCase(deleteWorkOrder.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
        state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
      })
      .addCase(deleteWorkOrder.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(unArchiveWorkOrder.pending, state => {
        state.status = 'loading';
      })
      .addCase(unArchiveWorkOrder.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
      })
      .addCase(unArchiveWorkOrder.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const {
  resetWorkOrderData,
  resetWorkOrderList,
  resetCurrentWorkOrderPage,
} = workorderSlice.actions;
export default workorderSlice.reducer;
